export default __webpack_public_path__ + "static/media/img2.90be0d1e.png";